import React from 'react';
import MarkDown from 'react-markdown';
import {connect,ConnectedProps} from 'react-redux';
import {AnyAction, bindActionCreators,Dispatch} from 'redux';

import {getReleaseNotes} from '../../../../actions/releaseNotesActions';
import { StoreState} from '../../../../typescript/storeTypes';

export class ReleaseNotes extends React.PureComponent<Props> {
    render() {
        return (
            <div className="releasenotes">
                <MarkDown>
                    {this.props.notes}
                </MarkDown>
            </div>
        );
    }

    componentDidMount() {
        this.props.getReleaseNotes();
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type MappedProps = ConnectedProps<typeof connector>;

type Props = MappedProps;

function mapStateToProps(state: StoreState) {
    return {
        notes: state.releaseNotes.notes
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        getReleaseNotes
    }, dispatch);
}

export default connector(ReleaseNotes);
